import { createRouter, createWebHashHistory } from 'vue-router'
import { setAuthExpiryHandler } from '@/api/client'
import { useAuthStore } from '@/stores/auth'
import { businessCategoryConfigs, isBusinessCategoryKind } from '@/config/business-categories'
import { permissions } from '@/config/permissions'
import { routes } from './routes'
import { handleRouteLoadError } from './load-error'

declare module 'vue-router' {
  interface RouteMeta {
    title?: string
    public?: boolean
    requiresAuth?: boolean
    permission?: string
    menuKey?: string
    hidden?: boolean
  }
}

const router = createRouter({ history: createWebHashHistory(), routes })
router.onError(handleRouteLoadError)

function safeRedirect(value: unknown): string {
  return typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')
    ? value
    : '/dashboard'
}

router.beforeEach((to) => {
  const auth = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)
  if (requiresAuth && !auth.isAuthenticated)
    return { path: '/login', query: { redirect: to.fullPath } }
  if (to.path === '/login' && auth.isAuthenticated) return '/dashboard'
  const kind = to.params.kind
  if (to.path.startsWith('/catalog/business/')) {
    if (!isBusinessCategoryKind(kind)) return '/404'
    const config = businessCategoryConfigs[kind]
    if (!auth.hasPermission(permissions.goodsView)) return '/403'
    to.meta.title = `${config.label}分类`
    to.meta.menuKey = `/catalog/business/${kind}`
  }
  const permission = to.meta.permission
  if (permission && !auth.hasPermission(permission)) return '/403'
  return true
})

router.afterEach((to) => {
  document.title = to.meta.title ? `${to.meta.title} - 五色惠运营管理平台` : '五色惠运营管理平台'
})

setAuthExpiryHandler(async () => {
  const redirect = router.currentRoute.value.fullPath
  useAuthStore().clear()
  await router.replace({ path: '/login', query: { redirect: safeRedirect(redirect) } })
})

export { safeRedirect }
export default router
